module.exports = __webpack_public_path__ + "static/log-cutting-8f4e0e3e3003414d9d24641005fad6d2.png";